import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Page } from '../../models/page.model';
import { Authority } from '../../models/authority.model';
import { AuthorityService } from '../../services/authority.service';


@Injectable({ providedIn: 'root' })
export class AuthorityListResolver implements Resolve<Page<Authority>> {

    constructor(private authorityService: AuthorityService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Page<Authority>>
        | Promise<Page<Authority>> | Page<Authority> {

        const params = new HttpParams()
            .set('page', '0')
            .set('size', '100');

        return this.authorityService.getAuthorityList(params);
    }
}
